'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tab = void 0;
const $ = require("jquery");
class Tab {
    constructor() {
        $('.trigTabContent').on('click', (e) => {
            $('.trigTabContent').attr('data-is-show', 'false');
            // $(e.currentTarget).attr('data-is-show', 'true');
            const tabNumber = Number($(e.currentTarget).attr('data-number'));
            $('.bulletTabContent').hide();
            $(`.bulletTabContent[data-number="${tabNumber}"]`).show();
            $(`.trigTabContent[data-number="${tabNumber}"]`).attr('data-is-show', 'true');
            //コンテンツトップに移動
            const element = document.getElementById('content-top');
            element.scrollIntoView({
                behavior: 'smooth'
            });
            //スマホの場合インデックス下に
            $('.tab').attr('data-scroll', 'appear');
        });
    }
}
exports.Tab = Tab;
exports.default = Tab;
